import React from 'react';
import {Card, Flex} from 'antd';
import BrandSlider from "../components/brandSlider";
import products from "../Data/ProductsData";

const Products = () => {

    const groupedBrands = [];
    const half = Math.ceil(products.length / 2);

    groupedBrands.push(products.slice(0, half));
    groupedBrands.push(products.slice(half));

    return (

        <Flex vertical className="text-center justify-center align-middle md:gap-4 mt-40">


            <Card
                className="max-w-full mx-auto relative shadow-md rounded-lg overflow-hidden"
                styles={{
                    header: {
                        padding: 0, margin: 0, border: 0
                    }, body: {
                        padding: 0
                    }
                }}
            >
                <img
                    src="../images/bg01.png" // replace with your image path
                    alt="Decorative Background"
                    className="absolute bottom-0 right-0 top-0 left-0 m-auto h-full w-auto  opacity-10 pointer-events-none select-none"
                />
                <h2 className="text-4xl pt-10 pb-5 md:text-5xl text-[#031c3f] font-bold text-center">
                    OUR PRODUCTS
                </h2>
                {groupedBrands.map((brands, index) => (<div key={index} className="w-full mb-4">
                    <BrandSlider brands={brands}/>
                </div>))}
            </Card>
        </Flex>);
};

export default Products;
